import React from 'react';
import { X, ShieldCheck } from 'lucide-react';
import { Job } from '../../types';
import { JobCompletionPhoto } from './JobCompletionPhoto';

interface CompletionPhotoUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  job: Job;
  professionalId: string;
  onSuccess: () => void;
}

export const CompletionPhotoUploadModal: React.FC<CompletionPhotoUploadModalProps> = ({
  isOpen,
  onClose,
  job,
  professionalId,
  onSuccess,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-xs animate-fade-in">
      <div className="bg-white rounded-3xl max-w-lg w-full shadow-2xl border border-slate-100 overflow-hidden flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="bg-slate-900 text-white p-6 relative">
          <button
            type="button"
            onClick={onClose}
            className="absolute top-5 right-5 text-slate-400 hover:text-white transition-colors cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-400 text-xs font-bold border border-emerald-500/30 mb-2">
            <ShieldCheck className="w-4 h-4" />
            <span>Upload Completion Photo</span>
          </div>
          <h2 className="text-xl sm:text-2xl font-black">Job Completion Evidence</h2>
          <p className="text-xs text-slate-300 mt-1">
            Job: <strong>{job.title}</strong> ({job.lga}, {job.state})
          </p>
        </div>

        {/* Content Body with JobCompletionPhoto */}
        <div className="p-6 overflow-y-auto">
          <JobCompletionPhoto
            job={job}
            professionalId={professionalId}
            maxSizeKB={200}
            onCompletionSubmitted={(res) => {
              if (res.success) {
                setTimeout(() => {
                  onSuccess();
                  onClose();
                }, 1200);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

